import { apiClient } from "@/config/api";
import {
  KKMovie,
  CreateKKMovieDto,
  UpdateKKMovieDto,
  GetPaginationKKMoviesDto,
  KKMovieListResponse,
} from "@/types/kkmovie";
import { ApiResponse } from "@/types/status";

const KKMOVIE_ENDPOINTS = {
  CREATE: "/kkmovies",
  GET_ALL: "/kkmovies",
  GET_BY_ID: (id: string) => `/kkmovies/${id}`,
  GET_BY_URL: (url: string) => `/kkmovies/url/${url}`,
  UPDATE: (id: string) => `/kkmovies/${id}`,
  DELETE: (id: string) => `/kkmovies/${id}`,
} as const;

export const kkmovieService = {
  // Tạo KKMovie mới
  create: async (data: CreateKKMovieDto): Promise<ApiResponse<KKMovie>> => {
    return await apiClient.post(KKMOVIE_ENDPOINTS.CREATE, data);
  },

  // Lấy danh sách KKMovies với phân trang
  getPaginationKKMovies: async (
    params: GetPaginationKKMoviesDto
  ): Promise<ApiResponse<KKMovieListResponse>> => {
    return await apiClient.get(KKMOVIE_ENDPOINTS.GET_ALL, params as any);
  },

  // Lấy tất cả KKMovies
  getAllKKMovies: async (): Promise<ApiResponse<KKMovie[]>> => {
    return await apiClient.get(KKMOVIE_ENDPOINTS.GET_ALL);
  },

  // Lấy KKMovie theo ID
  getKKMovieById: async (id: string): Promise<ApiResponse<KKMovie>> => {
    return await apiClient.get(KKMOVIE_ENDPOINTS.GET_BY_ID(id));
  },

  // Lấy KKMovie theo URL (slug)
  getKKMovieByUrl: async (url: string): Promise<ApiResponse<KKMovie>> => {
    return await apiClient.get(KKMOVIE_ENDPOINTS.GET_BY_URL(url));
  },

  // Cập nhật KKMovie
  updateKKMovie: async (
    id: string,
    data: UpdateKKMovieDto
  ): Promise<ApiResponse<KKMovie>> => {
    return await apiClient.put(KKMOVIE_ENDPOINTS.UPDATE(id), data);
  },

  // Xóa KKMovie (soft delete)
  deleteKKMovie: async (id: string): Promise<ApiResponse<void>> => {
    return await apiClient.delete(KKMOVIE_ENDPOINTS.DELETE(id));
  },
};
